import { Component, EventEmitter, Output } from "@angular/core";

@Component({
    selector: "app-options",
    templateUrl: "./options.component.html",
    standalone: false
})
export class OptionsComponent {
  currentLang = "en";
  showSettings = false;
  options = {
    collapsed: false,
    boxed: false,
    dark: false,
    dir: "ltr",
  };

  @Output()
  messageEvent = new EventEmitter();

  constructor() {}

  sendOptions() {
    this.messageEvent.emit(this.options);
  }
}
